import { render } from "./MoleculeTabWindow.vue?vue&type=template&id=8f738ec6&ts=true"
import script from "./MoleculeTabWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeTabWindow.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/molecules/MoleculeTabWindow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8f738ec6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8f738ec6', __exports__)) {
    api.reload('8f738ec6', __exports__)
  }
  
  module.hot.accept("./MoleculeTabWindow.vue?vue&type=template&id=8f738ec6&ts=true", () => {
    api.rerender('8f738ec6', render)
  })

}


export default __exports__